var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-breadcrumb',{attrs:{"page-title":_vm.$t('job_settings')}}),_vm._v(" "),_c('app-tab',{staticClass:"job-setting-tab",attrs:{"tabs":_vm.tabs,"icon":_vm.pageIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }